import * as React from 'react';
import { withIdentity, IdentityProps } from "../services/authentication";
import { Avatar, Menu, Dropdown, Tooltip } from 'antd';
const MenuItem = Menu.Item;
import { withTranslation, WithTranslation } from 'react-i18next'
import { resolve } from 'src/inversify.config';
import { PreferencesService } from 'src/core/services/preferences.service';
import { ClickParam } from 'antd/lib/menu';
import moment from 'moment';
import i18next from 'i18next';
import { NavItem } from './shell-header';
const esFlag = require('../assets/images/flags/es.png');
const enFlag = require('../assets/images/flags/uk.png');
const frFlag = require('../assets/images/flags/fr.png');
const ptFlag = require('../assets/images/flags/ptPT.png');
const brFlag = require('../assets/images/flags/ptBR.png');
const itFlag = require('../assets/images/flags/it.png');
const deFlag = require('../assets/images/flags/de.png');
import HttpService from "../services/http.service";

interface LanguageBoxProps extends WithTranslation, IdentityProps {
  isMobileOrTablet?: boolean,
  languages: string[],
}

interface LanguageBoxState {
  language: string
}

class LanguageBox extends React.Component<LanguageBoxProps, LanguageBoxState> {
  @resolve(PreferencesService)
  private readonly preferencesService!: PreferencesService;

  private languages = [
    { key: 'en', value: 'English', flag: enFlag },
    { key: 'es', value: 'Spanish', flag: esFlag },
    { key: 'fr', value: 'French', flag: frFlag },
    { key: 'pt', value: 'Portuguese', flag: ptFlag },
    { key: 'pt-br', value: 'Portuguese', flag: brFlag },
    { key: 'it', value: 'Italian', flag: itFlag },
    { key: 'de', value: 'German', flag: deFlag }
  ]

  constructor(props: LanguageBoxProps) {
    super(props);
    this.state = {
      language: 'en',
    }
    this.onChangeLanguage = this.onChangeLanguage.bind(this);
    this.getBrowserLanguage = this.getBrowserLanguage.bind(this);
    this.configureLanguage = this.configureLanguage.bind(this);
  }

  componentWillMount() {
    if (this.preferencesService) {
      this.preferencesService.current().then(prefs => {
        if (prefs && prefs.currentLanguage) {
          this.configureLanguage(prefs.currentLanguage);
        } else {
          this.configureLanguage(this.getBrowserLanguage());
        }
      }).catch(error => {
        this.configureLanguage(this.getBrowserLanguage());
      });
    }
  }

  private getBrowserLanguage() {
    var supportedLangs = this.languages.map(o => o.key);
    var language: string = window.navigator.language || (window.navigator as any).userLanguage || supportedLangs[0];
    supportedLangs.forEach(lang => {
      if (language && language == lang || language.startsWith(lang))
        language = lang;
    });
    return language || supportedLangs[0];
  }

  private configureLanguage(language: string) {
    moment.locale(language);
    i18next.changeLanguage(language);
    this.setState({ language: language });
    HttpService.language = language;
  }

  private onChangeLanguage(value: ClickParam) {

    this.preferencesService.setCurrentLanguage(value.key);
    this.configureLanguage(value.key);
    HttpService.language = value.key;
  }

  public render() {
    const { t } = this.props;

    if (!this.state.language)
      return <div></div>;
    var languages = this.languages.filter(x => !this.props.languages || this.props.languages.includes(x.key));
    var currentLanguages = languages.filter(o => o.key == this.state.language);
    if (currentLanguages.length == 0)
      currentLanguages = languages
    var currentLanguage = currentLanguages[0];
    return <NavItem title={t(currentLanguage.value)}
      icon={<Avatar size={this.props.isMobileOrTablet ? "small" : "default"} shape="square" src={currentLanguage.flag} />}
      subMenu={<Menu onClick={this.onChangeLanguage}>
        {languages.map(lang => <MenuItem key={lang.key}>
          <Avatar size="default" shape="square" src={lang.flag} />
          <span style={{ marginLeft: 10 }}>{t(lang.value)}</span>
        </MenuItem>
        )}
      </Menu>}>
    </NavItem>

  }
}
export default withTranslation()(withIdentity(LanguageBox));